import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lcl-additional-product-attach',
  templateUrl: './lcl-additional-product-attach.component.html',
  styleUrls: ['./lcl-additional-product-attach.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LclAdditionalProductAttachComponent {
  @Input() public isIsf: boolean;
  @Input() public isProductRequested: boolean;
  @Input() public isViewMode: boolean;
  @Input() public warning: { isShowWarning: boolean; isShowHeaderWarning: boolean; message: string };
  @Output() public onFileAdditionalDocsSource: EventEmitter<void> = new EventEmitter<void>();

  constructor(private translateService: TranslateService) {}

  public productName(isIsf: boolean): string {
    return this.translateService.instant(isIsf ? 'LABELS.ISF' : 'LABELS.ENTRY_SUMMARY');
  }

  public onFileAdditionalDocs(): void {
    if (this.isViewMode) {
      return;
    }
    this.onFileAdditionalDocsSource.emit();
  }
}
